import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoHourglass = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Hourglass</title>
    <path
      d="M14.142 18.418v-2.903c-1.529-.502-2.657-1.494-3.592-2.687-2.658-3.391-2.693-8.406-2.693-8.406h18.285s-.128 5.015-2.787 8.406c-.935 1.193-1.97 2.185-3.499 2.687v2.903"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.855 18.38c1.715.897 2.642 1.506 3.577 2.709 2.659 3.418 2.71 8.473 2.71 8.473H7.856s.15-5.055 2.809-8.473c.935-1.203 1.762-1.812 3.476-2.71"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.285 27.277H10.713c0-2.286 1.679-3.726 2.304-3.824 1.125-.176 1.437.264 2.84.395 1.401.132 2.979-1.142 3.666-1.142.785 0 2.619 0 3.762 4.57ZM11.989 11.257c.59.918 2.947 2.753 4.715 2.753 2.947 0 5.305-2.294 5.305-3.67-.59.153-2.122.459-3.537.459-1.768 0-2.357-.918-3.536-.918-1.179 0-1.768.459-2.947 1.376Z"
      fill="currentColor"
    />
    <path d="m16.962 18.43-.99-4.69h1.98l-.99 4.69Z" fill="currentColor" />
    <path d="m16.961 17.443.99 6.58h-1.98l.99-6.58Z" fill="currentColor" />
  </svg>
);
export default SvgIcoHourglass;
